import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent extends Toast {
  get isError(): boolean {
    return this.toastPackage.toastType === 'toast-error';
  }

  get titleText(): string {
    return this.title();
  }

  get descriptionText(): string {
    return this.message();
  }
}
